import * as FullStory from '@fullstory/browser';
import { toRelativeUrl } from '@okta/okta-auth-js';
import { Security } from '@okta/okta-react';
import { GlobalStyles, GlobalStylesProvider } from '@triumph/design-system';
import { useEffect } from 'react';
import { BrowserRouter, useNavigate } from 'react-router-dom';

import AppContextProvider from './components/providers/AppContextProvider';
import { PageRouter } from './components/router/PageRouter';
import { PageRoutes } from './components/router/routes';
import { Page } from './page.styles';
import { Config } from './shared/utils/config';
import { useAppOktaAuth } from './shared/utils/hooks/useAppOktaAuth';
import './translations/i18n';

export const App = () => {
    const navigate = useNavigate();
    const oktaAuth = useAppOktaAuth();

    const restoreOriginalUri = (_oktaAuth: any, originalUri: string) => {
        navigate(
            toRelativeUrl(
                originalUri || PageRoutes.DASHBOARD,
                window.location.origin,
            ),
        );
    };

    useEffect(() => {
        FullStory.init({
            orgId: Config.FullStoryOrganizationId,
            devMode: Config.Environment === 'local',
        });
    }, []);

    return (
        <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
          <AppContextProvider>
              <GlobalStylesProvider StylesComponent={<GlobalStyles />}>
                  <Page>
                      <PageRouter />
                  </Page>
              </GlobalStylesProvider>
          </AppContextProvider>
        </Security>
    );
};

export default App;
